module.exports = __webpack_public_path__ + "img/top_image_sentiment.dbaece2f.png";